import type { IDataset, JsonPrimitive } from '@se/cp.common';
import { Moment } from 'moment';

export interface IDatasetResponseDTO {
    idGroup: string;
    jsonMetadata: IDataset;
}

export enum ClinicalRepositoryDataType {
    Xml,
    XmlCustom,
    Image,
}

export interface ClinicalRepositoryData {
    id: string;
    data: string;
    type: ClinicalRepositoryDataType;
}

export interface PatientHistoryRequest {
    maxReturnedExams: number;
    idPatient: string;
    thresholdDate: string;
    idModelTypeRootList?: string[];
    idCustomPageRoot?: string;
    bindings: string[];
}

export interface ImportReportListRequest {
    maxReturnedExams: number;
    idPatient: string;
    thresholdDate: Moment;
    idModelTypeRootList: string[];
}

export interface IBasePatientHistory {
    idExaminations: string[];
    reportDate: string;
    examDescription: string;
    businessUnitDescription: string;
    requestedValues?: any[];
}

export type IPatientHistory = IBasePatientHistory & Partial<Record<string, JsonPrimitive>>;
